import { cx } from '@linaria/core';
import { SpeechButton } from '@ui/kit';
import { SpeakerIcon } from '@ui/kit/icons';
import { useOpgavekompleksetComponent } from '../../state/context.data.js';
import { readOutLoudButton } from './_speech-synthesis.style.js';
import { jsx } from 'react/jsx-runtime';

function OpgaveKompleksetSpeechSynthesis(props) {
  const component = useOpgavekompleksetComponent();
  if (component.data.settings.standalone.audience !== "young") {
    return;
  }
  return /*#__PURE__*/jsx(SpeechButton, {
    wrapperClassName: props.wrapperClassName,
    className: cx(readOutLoudButton, props.className),
    rootSelector: `#${props.id}`,
    tooltipPlacement: "top",
    defaultIcon: /*#__PURE__*/jsx(SpeakerIcon, {
      height: 18
    }),
    hideFlags: true,
    disableSelection: true,
    withoutGuideBubble: true,
    ...props
  });
}

export { OpgaveKompleksetSpeechSynthesis };
//# sourceMappingURL=_speech-synthesis.js.map
